import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class CardReceiptAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'CardReceiptAllocation';

}
